import { Outlet } from 'react-router-dom';
import { useUserStore } from 'providers/RootStoreProvider';
import { useEffect } from 'react';

const AccountLayout = () => {
    const { checkUserSubscription } = useUserStore();

    useEffect(() => {
        checkUserSubscription();
    }, []);

    return <Outlet />;
};

export default AccountLayout;
